import { type ReactNode, useState } from 'react'

import { BreadcrumbContext, type BreadcrumbItem } from './BreadcrumbContext'

export const BreadcrumbProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([])
  const [pageTitle, setPageTitle] = useState<string | null>(null)

  return (
    <BreadcrumbContext.Provider value={{ breadcrumbs, setBreadcrumbs, pageTitle, setPageTitle }}>
      {children}
    </BreadcrumbContext.Provider>
  )
}
